import React, { Component } from "react";
import footerImage from "../../images/footerImage.png";
import { isNullOrUndefined } from "../HWLibrary/HWUtils";

class DefaultFooter extends Component {
  render() {
    const isFooterVisible =
      this.props.config.configDetails.displayFooter === true;
    const isFullScreen = localStorage.getItem("openInFullScreen");
    return (
      <div
        className={
          isFullScreen
            ? "s360-conversation-page-footer-brand-container-fs"
            : "s360-conversation-page-footer-brand-container"
        }
        ref={this.props.conversationFooterRef}
      >
        {this.props.config.configDetails.footerBrandText === "" &&
          this.props.visiblePage != "conversationPage" && (
            <div
              className="s360-default-footer-first"
              style={this.footerStyle()}
            >
              {/* <div className="s360-default-footer-text"  style={{visibility: isFooterVisible ? "visible" : "hidden",fontFamily:"poppins", paddingLeft: this.props.visiblePage =="conversationPage" ?"0px":"0px",paddingTop:'10px'}} >{this.props.config.configDetails.footerText}</div> */}
              {/* <div className="s360-default-footer-image-container"> */}
              <img
                style={{ cursor: "pointer",width:'25px' }}
                onClick={() => {
                  if (isFooterVisible)
                    window.open(this.props.config.configDetails.footerLink);
                }}
                src={this.props?.config?.configDetails?.footerIcon}
                alt="footer"
              ></img>
              {/* <div className="s360-default-footer-text s360-default-footer-text-suffix"  style={{visibility: isFooterVisible ? "visible" : "hidden",paddingTop:'10px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',height:'2rem'}} >
          {this.props.config.configDetails.footerIcon && <img src={this.props.config.configDetails.footerIcon} style={{maxWidth: this.props.config.designDetails.iconWidth, height: "28px", objectFit:"contin", alignSelf: "center",visibility: isFooterVisible ? "visible" : "hidden", display: isFooterVisible ? "block" : "none",marginTop:'0px' }} alt="" />}
          {this.props.config.configDetails.footerBrandText || ""}
          </div> */}
              {/* </div> */}
              {/* src="https://dev.simplify360.com/whitelabel/2/images/sf360_colored_logo.png" */}
            </div>
          )}

        {this.props.config.configDetails.footerText === "" && this?.props?.config?.configDetails?.footerIcon !=="simplify360_logo.png" &&
          this.props.visiblePage === "conversationPage" && (
            <div
              // className="s360-default-footer-second"
              className={
                isFullScreen
                  ? "s360-default-footer-second-hide"
                  : "s360-default-footer-second"
              }
              style={this.footerStyle()}
            >
              {/* <div className="s360-default-footer-text"  style={{visibility: isFooterVisible ? "visible" : "hidden",fontFamily:"poppins", paddingLeft: this.props.visiblePage =="conversationPage" ?"0px":"0px",paddingTop:'10px'}} >{this.props.config.configDetails.footerText}</div> */}
              {/* <div className="s360-default-footer-image-container"> */}
              <img
                style={{ cursor: "pointer", width: "60px" }}
                onClick={() => {
                  if (isFooterVisible)
                    window.open(this.props.config.configDetails.footerLink);
                }}
                src={this?.props?.config?.configDetails?.footerIcon}
                alt="footer"
              ></img>
              {/* <div className="s360-default-footer-text s360-default-footer-text-suffix"  style={{visibility: isFooterVisible ? "visible" : "hidden",paddingTop:'10px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',height:'2rem'}} >
          {this.props.config.configDetails.footerIcon && <img src={this.props.config.configDetails.footerIcon} style={{maxWidth: this.props.config.designDetails.iconWidth, height: "20px", objectFit:"contin", alignSelf: "center",visibility: isFooterVisible ? "visible" : "hidden", display: isFooterVisible ? "block" : "none",marginTop:'0px' }} alt="" />}
          {this.props.config.configDetails.footerBrandText || ""}
          </div> */}
              {/* </div> */}
              {/* src="https://dev.simplify360.com/whitelabel/2/images/sf360_colored_logo.png" */}
            </div>
          )}
        {this.props.config.configDetails.footerBrandText !== "" &&
          this.props.visiblePage !== "conversationPage" && (
            <div
              className="s360-default-footer-third"
              style={this.footerStyle()}
            >
              {/* <div className="s360-default-footer-text"  style={{visibility: isFooterVisible ? "visible" : "hidden",fontFamily:"poppins", paddingLeft: this.props.visiblePage =="conversationPage" ?"0px":"0px",paddingTop:'10px'}} >{this.props.config.configDetails.footerText}</div> */}
              {/* <div className="s360-default-footer-image-container"> */}
              <img
                style={{ cursor: "pointer",width:'60px' }}
                onClick={() => {
                  if (isFooterVisible)
                    window.open(this.props.config.configDetails.footerLink);
                }}
                src={footerImage}
                alt="footer"
              ></img>
              {/* <div className="s360-default-footer-text s360-default-footer-text-suffix"  style={{visibility: isFooterVisible ? "visible" : "hidden",paddingTop:'10px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',height:'2rem'}} >
          {this.props.config.configDetails.footerIcon && <img src={this.props.config.configDetails.footerIcon} style={{maxWidth: this.props.config.designDetails.iconWidth, height: "20px", objectFit:"contin", alignSelf: "center",visibility: isFooterVisible ? "visible" : "hidden", display: isFooterVisible ? "block" : "none",marginTop:'0px' }} alt="" />}
          {this.props.config.configDetails.footerBrandText || ""}
          </div> */}
              {/* </div> */}
              {/* src="https://dev.simplify360.com/whitelabel/2/images/sf360_colored_logo.png" */}
            </div>
          )}
        {this.props.config.configDetails.footerText !== "" &&
          this.props.visiblePage === "conversationPage" && (
            <div

              className={
                isFullScreen
                  ? "s360-default-footer-fourth-fs"
                  : "s360-default-footer-fourth"
              }
              style={this.footerStyle()}
            >
              {
                <div
                  className={
                    localStorage.getItem("openInFullScreen")
                      ? "s360-default-footer-sub-text-fs"
                      : "s360-default-footer-sub-text"
                  }
                  style={{
                    visibility: isFooterVisible ? "visible" : "hidden",
                    fontFamily: "poppins",
                    paddingLeft:
                      this.props.visiblePage == "conversationPage"
                        ? "0px"
                        : "0px",
                    
                  }}
                >
                  {this.props.config.configDetails.footerText}
                </div>
              }
              {
                <div
                  className={
                    localStorage.getItem("openInFullScreen")
                      ? "s360-default-footer-text-fs"
                      : "s360-default-footer-text"
                  }
                  style={{
                    visibility: isFooterVisible ? "visible" : "hidden",
                    fontFamily: "poppins",
                    paddingLeft:
                      this.props.visiblePage == "conversationPage"
                        ? "0px"
                        : "0px",
                    
                  }}
                  onClick={() => {
                    if (isFooterVisible)
                      window.open(this.props.config.configDetails.footerLink);
                  }}
                >
                  {this.props.config.configDetails.footerBrandText}
                </div>
              }
              {/* <div className="s360-default-footer-image-container"> */}
              {this.props.config.configDetails.footerIcon !== " " && (
                <img
                  style={{ cursor: "pointer",width:'60px' }}
                  onClick={() => {
                    if (isFooterVisible)
                      window.open(this.props.config.configDetails.footerLink);
                  }}
                  src={footerImage}
                  alt="footer"
                ></img>
              )}
              {/* <div className="s360-default-footer-text s360-default-footer-text-suffix"  style={{visibility: isFooterVisible ? "visible" : "hidden",paddingTop:'10px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',height:'2rem'}} >
          {this.props.config.configDetails.footerIcon && <img src={this.props.config.configDetails.footerIcon} style={{maxWidth: this.props.config.designDetails.iconWidth, height: "20px", objectFit:"contin", alignSelf: "center",visibility: isFooterVisible ? "visible" : "hidden", display: isFooterVisible ? "block" : "none",marginTop:'0px' }} alt="" />}
          {this.props.config.configDetails.footerBrandText || ""}
          </div> */}
              {/* </div> */}
              {/* src="https://dev.simplify360.com/whitelabel/2/images/sf360_colored_logo.png" */}
            </div>
          )}
      </div>

      // <div className="s360-default-footer" style={this.footerStyle()} onClick={() => { if (isFooterVisible) window.open(this.props.config.configDetails.footerLink); }}>

      //        <div className="s360-default-footer-text"  style={{visibility: isFooterVisible ? "visible" : "hidden",fontFamily:"poppins", paddingLeft: this.props.visiblePage =="conversationPage" ?"0px":"0px",paddingTop:'10px'}} >{this.props.config.configDetails.footerText}</div>
      //        {/* <div className="s360-default-footer-image-container"> */}

      //         <div className="s360-default-footer-text s360-default-footer-text-suffix"  style={{visibility: isFooterVisible ? "visible" : "hidden",paddingTop:'10px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',height:'2rem'}} >
      //         {this.props.config.configDetails.footerIcon && <img src={this.props.config.configDetails.footerIcon} style={{maxWidth: this.props.config.designDetails.iconWidth, height: "20px", objectFit:"contin", alignSelf: "center",visibility: isFooterVisible ? "visible" : "hidden", display: isFooterVisible ? "block" : "none",marginTop:'0px' }} alt="" />}
      //         {this.props.config.configDetails.footerBrandText || ""}
      //         </div>
      //         {/* </div> */}
      //        {/* src="https://dev.simplify360.com/whitelabel/2/images/sf360_colored_logo.png" */}
      // </div>
    );
  }
  //footer link
  //  footerLinkSvg=()=>{
  //   return ()
  //  }

  //
  footerStyle = () => {
    return {
      display:'none',
      color: this.props.config.designDetails.footerFontColor,
      fontFamily: this.props.config.designDetails.footerFont,
      fontSize: this.props.config.designDetails.footerFontSize + "px",
      width: "100%",
      height: "30px",
      position:
        this.props.visiblePage != "conversationPage" ? "absolute" : "initial",
      bottom: "0px",
      left: "0px",
      backgroundColor: isNullOrUndefined(
        this.props.config.designDetails.defaultFooterBackgroundColor
      )
        ? "none"
        : this.props.config.designDetails.defaultFooterBackgroundColor,

      // conditional
    };
  };
}

export default DefaultFooter;
